import { Packages } from '~shared/constants/pricing';

import { PackageColors, PackageTheme } from './types';
import { pricingPalette } from './colors';

export const packageColors: PackageColors = {
  advantageAnnual: pricingPalette.colors.sabaeus,
  advantageMonthly: pricingPalette.colors.sabaeus,
  basic: pricingPalette.colors.slate,
  flex: pricingPalette.colors.arctic,
  enterprise: pricingPalette.colors.midnight,
  premierAnnual: pricingPalette.colors.midnight,
  starterMonthly: pricingPalette.colors.link,
  premierMonthly: pricingPalette.colors.midnight,
  starterAnnual: pricingPalette.colors.link,
  standardMonthly: pricingPalette.colors.arctic,
  standardAnnual: pricingPalette.colors.arctic,
  teamAdvantage: pricingPalette.colors.link,
  teamPremier: pricingPalette.colors.concord,
  forms: pricingPalette.colors.concord,
};

export const packageTheme: PackageTheme = {
  [Packages.AdvantageAnnual]: {
    primary: packageColors.advantageAnnual,
  },
  [Packages.AdvantageMonthly]: {
    primary: packageColors.advantageMonthly,
  },
  [Packages.Basic]: {
    primary: packageColors.basic,
  },
  [Packages.Enterprise]: {
    primary: packageColors.enterprise,
  },
  [Packages.PremierAnnual]: {
    primary: packageColors.premierAnnual,
  },
  [Packages.StarterMonthly]: {
    primary: packageColors.starterMonthly,
  },
  [Packages.PremierMonthly]: {
    primary: packageColors.premierMonthly,
  },
  [Packages.StarterAnnual]: {
    primary: packageColors.starterAnnual,
  },
  [Packages.StandardMonthly]: {
    primary: packageColors.standardMonthly,
  },
  [Packages.StandardAnnual]: {
    primary: packageColors.standardMonthly,
  },
  [Packages.TeamAdvantage]: {
    primary: packageColors.teamAdvantage,
  },
  [Packages.TeamPremier]: {
    primary: packageColors.teamPremier,
  },
  [Packages.Flex]: {
    primary: packageColors.standardMonthly,
  },
  [Packages.FormsAnnual]: {
    primary: packageColors.forms,
  },
  [Packages.FormsMonthly]: {
    primary: packageColors.forms,
  },
};

export const pricingElevation: Record<string, number> = {
  zero: 0,
  minusOne: -1,
  plusOne: 1,
};
